import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Link } from "@/lib/navigation";
import styles from "./CookieConsent.module.css";
import { grantGtagConsent, denyGtagConsent } from "@/lib/gtag";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add a slight delay before showing the consent modal
    const timer = setTimeout(() => {
      const consent = Cookies.get("cookie-consent");
      if (!consent) {
        setIsVisible(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const acceptCookies = () => {
    // Set consent cookie
    Cookies.set("cookie-consent", "accepted", { expires: 365 });

    void grantGtagConsent();

    setIsVisible(false);
  };

  const declineCookies = () => {
    // Set consent cookie to declined
    Cookies.set("cookie-consent", "declined", { expires: 365 });

    denyGtagConsent();

    // Remove all non-essential cookies
    const cookies = Cookies.get();
    Object.keys(cookies).forEach((cookie) => {
      // Keep only essential cookies
      if (!["cookie-consent", "auth"].includes(cookie)) {
        Cookies.remove(cookie);
      }
    });

    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className={styles.cookieConsent}>
      <div className={styles.content}>
        <h3 className={styles.title}>🍪 Cookie Settings</h3>
        <p className={styles.text}>
          We use cookies to enhance your experience. Essential cookies will
          remain enabled to ensure the site functions properly.{" "}
          <Link to="/privacy" className={styles.link}>
            Learn more
          </Link>
          .
        </p>
        <div className={styles.buttons}>
          <button onClick={declineCookies} className={styles.declineButton}>
            Essential Only
          </button>
          <button onClick={acceptCookies} className={styles.acceptButton}>
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
